import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './Home';
import BookingPage from './Booking';
import MyBookingsPage from './MyBookings';
import LabManagementPage from './LabManagement';
import BookingManagementPage from './BookingManagement';
import { useKeycloak } from './KeycloakContext';
import LoadingPage from './Loading';

const PrivateRoute = ({ children, role }) => {
  const { keycloak, keycloakInitialized, hasRole } = useKeycloak();

  if (!keycloakInitialized) {
    return <LoadingPage />;
  }

  if (!keycloak.authenticated || !hasRole(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const RedirectBasedOnRole = () => {
  const { hasRole } = useKeycloak();

  if (hasRole("UNIVERSITY")) {
    return <Navigate to="/lab-management" replace />;
  }

  if (hasRole("SCHOOL")) {
    return <Navigate to="/home" replace />;
  }

  return <LoadingPage />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RedirectBasedOnRole />} />
        <Route path="/home" element={
          <PrivateRoute role="SCHOOL">
            <HomePage />
          </PrivateRoute>
        } />
        <Route path="/booking/:id" element={
          <PrivateRoute role="SCHOOL">
            <BookingPage />
          </PrivateRoute>
        } />
        <Route path="/my-bookings" element={
          <PrivateRoute role="SCHOOL">
            <MyBookingsPage />
          </PrivateRoute>
        } />
        <Route path="/lab-management" element={
          <PrivateRoute role="UNIVERSITY">
            <LabManagementPage />
          </PrivateRoute>
        } />
        <Route path="/booking-management" element={ // Add the new route
          <PrivateRoute role="UNIVERSITY">
            <BookingManagementPage />
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
};

export default App;
